import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import jobs from '../../../data/jobs/jobs.json';
import Slider from "react-slick";

const settings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dotsClass: "slick-dots d-flex",
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 500,
    cssEase: 'linear',
    responsive: [{
        breakpoint: 1200,
        settings: {
            arrows: true,
            slidesToShow: 3
        }
    }, {
        breakpoint: 992,
        settings: {
            arrows: true,
            slidesToShow: 2
        }
    }, {
        breakpoint: 768,
        settings: {
            arrows: false,
            dots: true,
            slidesToShow: 2
        }
    }, {
        breakpoint: 576,
        settings: {
            arrows: false,
            dots: true,
            slidesToShow: 1
        }
    }]
}
class Jobs extends Component {
    render() {
        return (
            <section className="section-padding car-booking">
                <div className="container">
                    <div className="section-header text-center">
                        <div className="section-heading">
                            <h3 className="text-custom-black">Featured <span className="text-custom-blue">Jobs</span></h3>
                            <div className="section-description">
                                <p className="text-light-dark">Lorem Ipsum is simply dummy text of the printing and typesetting
                                    industry. Lorem Ipsum has been the industry's standard dummy text.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <Slider {...settings} className="car-slider arrow-layout-2 row">
                                {/* Item */}
                                {jobs.map((item, i) => (
                                    <div key={i} className="slide-item col-12">
                                        <div className="job-item mb-0">
                                            <img src={process.env.PUBLIC_URL + "/" + item.image} alt={item.title} />
                                            <div className="job-inner">
                                                <div className="job-inner-left">
                                                    <h3>{item.title}</h3>
                                                    <p className="mb-0">{item.companyname}</p>
                                                    <ul className="mb-3">
                                                        <li>${new Intl.NumberFormat().format((item.salary).toFixed(1))}</li>
                                                        <li>Location: {item.location}</li>
                                                    </ul>
                                                </div>
                                                <div className="job-inner-right">
                                                    <ul>
                                                        <li><Link to="/apply-now">Apply</Link></li>
                                                        <li><Link to={"/jobs-details/" + item.id} className="btn-first btn-small">View
                                                            Job</Link></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                {/* Item */}
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Jobs;